import styled from "styled-components";

export const Main = styled.div`
  background-color: #0E0F19;
  padding-top: 160px;
`